import React from 'react';
import StandaloneShell from '../../components/StandaloneShell';
import PermissionGate from '../../components/PermissionGate';
import Renewals from '../Renewals';

export default function RenewalsPage() {
  return (
    <StandaloneShell title="Renewals">
      {({ darkMode, T }) => (
        <PermissionGate module="renewals" moduleName="Renewals">
          <Renewals darkMode={darkMode} T={T} />
        </PermissionGate>
      )}
    </StandaloneShell>
  );
}
